// JavaScript source code
import React, { useState, useEffect }from 'react';
import { useParams, Link, useNavigate} from 'react-router-dom';
import SubHeader from '../components/subheader';
import SubFooter from '../components/subfooter';
import LeftNav from '../components/leftnav';
import LoginDialog from '../components/loginDialog';
import LoadingOverlay from '../components/loadingOverlay';
import MessageDialog from '../components/messageDialog';
import Cart from '../components/cart';
import { get, getUser, getCart } from '../request';
import ModifyContactDialog from '../components/modifyContactDialog';
import config from '../config';
function ContactManagement(props) {
    const activeIndex = 5;
    let params = useParams();
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState("");
    const [isShowLogin, setIsShowLogin] = useState(false);
    const [isShowModify, setIsShowModify] = useState(false);
    const [currentItem, setCurrentItem] = useState({name:""});
    const [isLoading, setShowLoading] = useState(false);
    const [cartlist, setCartlist] = useState([]);

    let user = getUser();
    const [list, setList] = useState([]);
    const [screenSize, setScreenSize] = useState(window.innerWidth);
    useEffect(() => {
        const handleResize = () => {
            setScreenSize(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    useEffect(() => {
        if (user == null || user.userType != 1) {
            setIsShowLogin(true);
            //history.goBack();
        }
        else if (user.business.businessStatus != 0) {
            setErrorMessage("签署正式入驻合同后，可使用我的德联！");
            //history.goBack();
        }
        else {
            fetchData();
            getCart().then(function (response) {
                if (response.statusCode !== 200) {
                    setErrorMessage("请重新登录！");
                    setIsShowLogin(true);
                    return;
                }
                setCartlist(response.items.filter(function (c) { return c.sku; }));
            });
        }
    }, []);
    const fetchData = () => {
        setShowLoading(true);
        get('delianapi/business/my').then((response) => {
            setShowLoading(false);
            if (response.statusCode !== 200 || response.items.length == 0) {
                return;
            }
            var business = response.items[0];
            setList(business.businessContactList);
        });
    }
    const handleLoginClick = () => {
        setIsShowLogin(true);
    }
    const finishLogin = () => {
        setIsShowLogin(false);
        //navigate("/JoinUsStep");
        user = getUser();
    }
    const finishModify = () => {
        setIsShowModify(false);
        fetchData();
    }
    
    const AddClick = () => {
        setCurrentItem({  name:"" });
        setIsShowModify(true);
    }
    const modifyClick = (item) => {
        setCurrentItem(item);
        setIsShowModify(true);
    }
    const closeModify = () => {
        setCurrentItem({ name: "" });
        setIsShowModify(false);
    }
    return (      
        <div className="mydelian contact" >
            <SubHeader activeIndex={activeIndex} user={user} setIsShowLogin={setIsShowLogin}/>
            <div className="content">
                <div className="detail" >
                    <LeftNav type={2} selectId={231} />
                    <div className="myContent">
                        <div className="title">
                            联系人管理
                            <div className="addNew" onClick={AddClick}> 新增联系人</div>
                        </div>
                        <div className="contactList">
                            {
                                list.map((item, index) => (

                                    <div className="contactItem" key={item.id}>
                                        <div className="contactName">{item.name}
                                            
                                            <div className="modify" onClick={()=>modifyClick(item)} >修改</div>
                                        </div>
                                        <div className="contactDetail"> 手机：{item.cellphone}</div>
                                        <div className="contactDetail"> 固话：{item.telephone}</div>
                                        <div className="contactDetail"> QQ：{item.qq}</div>
                                        <div className="contactDetail"> 微信：{item.wechat}</div>
                                        <div className="contactDetail"> Email：{item.Email}</div>
                                    </div>
                                ))
                            }
                            
                        </div>

                    </div>
                    <div className="addNew mobile-show" onClick={AddClick}> 新增联系人</div>

                </div>
            </div>
            {
                cartlist &&
                <Cart num={cartlist.length} />
            }
            <SubFooter />
            <LoginDialog isShowLogin={isShowLogin} onCancel={finishLogin} />
            <ModifyContactDialog isShow={isShowModify} onConfirm={finishModify} onCancel={ closeModify} initItem={ currentItem} />
            
            <MessageDialog message={errorMessage} onCancel={() => {
                setErrorMessage("");
                navigate(-1);
            }} />
            <LoadingOverlay isLoading={isLoading}>
            </LoadingOverlay>

        </div>
          
    );
}

export default ContactManagement;